import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IsDatePipe } from './is-date.pipe';

@NgModule({
  declarations: [IsDatePipe],
  imports: [CommonModule],
  exports: [IsDatePipe]
})
export class IsDatePipeModule {}
